import moment from 'moment'
import { PeriodFilter } from "~/types/types"

interface DemoFilterStore {
  fetchReportingPeriod: () => void
  reportingPeriods: PeriodFilter[]
}

export default (): DemoFilterStore => {
  return {
    fetchReportingPeriod: () => { },
    reportingPeriods: [
      {
        from: moment().subtract(3, 'year').startOf('year'),
        to: moment().subtract(3, 'year').endOf('year'),
      },
      {
        from: moment().subtract(2, 'year').startOf('year'),
        to: moment().subtract(2, 'year').endOf('year'),
      },
      {
        from: moment().subtract(1, 'year').startOf('year'),
        to: moment().subtract(1, 'year').endOf('year'),
      },
      {
        from: moment().startOf('year'),
        to: moment().endOf('year'),
      },
    ],
  }
}
